import React, { useEffect, useMemo, useState } from "react";

import HttpManager from "../../../services/HttpManager";
import { errorTexto } from "./dialogos";

interface Persona { id: number; name: string; email: string; roles: string | null; jefa_user_id: number | null; jefa: string | null; origen: string | null; zoho_rol: string | null; }

/**
 * Organigrama (RRHH y superadmin): la jefa directa de cada persona. La jefa y todas las de arriba ven y editan los
 * archivos de su gente en WappDrive y leen sus chats de Equipo. Viene prellenado de los roles de Zoho; aquí se corrige.
 */
const Organigrama: React.FC<{ campusId: number }> = ({ campusId }) => {
	const http = HttpManager.getInstance().wappdriveService;
	const [p, setP] = useState<Persona[]>([]);
	const [puede, setPuede] = useState(false);
	const [q, setQ] = useState("");
	const [solo, setSolo] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const cargar = () => http.organigrama(campusId).then((r) => { setP(r.data.personas); setPuede(r.data.puede); }).catch((e) => setError(errorTexto(e)));
	useEffect(() => { cargar(); }, [campusId]);
	const lista = useMemo(() => p.filter((x) => (!solo || !x.jefa_user_id) && (!q || (x.name + " " + x.email + " " + (x.roles || "") + " " + (x.jefa || "")).toLowerCase().includes(q.toLowerCase()))), [p, q, solo]);
	const cambiar = async (id: number, jefa: string) => {
		setError(null);
		try { const r = await http.guardarJefa(campusId, id, jefa ? Number(jefa) : null); setP(r.data.personas); } catch (e) { setError(errorTexto(e)); }
	};
	return (
		<div className="wd-org">
			<div className="wd-org-barra">
				<input type="search" className="wd-input" placeholder="Buscar persona, rol o jefa" value={q} onChange={(e) => setQ(e.target.value)} />
				<label className="wd-check"><input type="checkbox" checked={solo} onChange={(e) => setSolo(e.target.checked)} /> Solo sin jefa ({p.filter((x) => !x.jefa_user_id).length})</label>
			</div>
			<p className="wd-tenue">La jefa directa y todas las personas arriba de ella ven y editan los archivos personales de su gente y leen sus chats de Equipo.</p>
			{error ? <div className="wd-aviso">{error}</div> : null}
			<div className="wd-tabla">
				<div className="wd-fila cab org"><span>Persona</span><span>Rol</span><span>Jefa directa</span></div>
				{lista.map((x) => (
					<div key={x.id} className="wd-fila org">
						<span><b>{x.name}</b><small className="wd-tenue"> {x.email}</small></span>
						<span className="wd-tenue">{x.roles || "—"}{x.zoho_rol ? " · Zoho: " + x.zoho_rol : ""}</span>
						<span>
							{puede ? (
								<select value={x.jefa_user_id || ""} onChange={(e) => cambiar(x.id, e.target.value)}>
									<option value="">— sin jefa —</option>
									{p.filter((y) => y.id !== x.id).map((y) => <option key={y.id} value={y.id}>{y.name}</option>)}
								</select>
							) : x.jefa || "—"}
							{x.origen === "manual" ? <span className="wd-chip">cambiada en WAPP</span> : null}
						</span>
					</div>
				))}
			</div>
		</div>
	);
};

export default Organigrama;
